// extracted by mini-css-extract-plugin
module.exports = {"cast_photo":"ContentDetailsCastSlider_cast_photo__3MEVh","cast_name":"ContentDetailsCastSlider_cast_name__3pVJU"};